@if (isLoading()) {
  <div class="min-h-screen bg-[#fafaf7] flex items-center justify-center font-sans">
    <div class="flex flex-col items-center gap-4">
      <div class="relative w-12 h-12">
        <div class="absolute inset-0 rounded-full border-4 border-stone-200"></div>
        <div class="absolute inset-0 rounded-full border-4 border-t-primary-400 animate-spin"></div>
      </div>
      <p class="text-stone-600 font-medium text-sm">Chargement…</p>
    </div>
  </div>
} @else {
  <div class="min-h-screen bg-[#fafaf7] flex">
    <app-sidebar></app-sidebar>

    <div class="flex-1 flex flex-col min-w-0">
      <div class="sticky top-0 z-30">
        <app-header [federationLogoUrl]="federationLogoUrl()" [accessLevel]="accessLevel()" (logoutEvent)="logout()"></app-header>
      </div>

      <main class="flex-1">
        @if (lostFederationNotice(); as notice) {
          <div role="alert" class="mx-4 sm:mx-6 mt-4 flex items-start gap-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800">
            <span class="material-icons text-base leading-5">warning</span>
            <p class="flex-1 min-w-0">{{ notice }}</p>
            <button type="button" (click)="dismissNotice()" aria-label="Fermer le message"
              class="flex-shrink-0 w-9 h-9 -my-2 -mr-2 inline-flex items-center justify-center rounded-lg hover:bg-amber-100">
              <span class="material-icons text-base">close</span>
            </button>
          </div>
        }
        @for (k of outletKey(); track k) {
          <router-outlet></router-outlet>
        }
      </main>
    </div>
  </div>
}
